import React from 'react'
import './styles.scss'

function Picture(props) {
  const img =
    'no' in props
      ? require(`../../images/content/${props.no}.jpg`)
      : 'src' in props ? require(`../../images/content/${props.src}`) : null
  return (
    <div
      className={`picture ${props.className ? props.className : ''}`}
      style={props.style}
    >
      {img && <img src={img} /> }
      {props.children && <div className='inner'>{props.children}</div>}
    </div>
  )
}

export default Picture
